<template>
  <div class="col-xl-6 mb-3 mb-xl-0" v-loading="loading">
    <card header-classes="bg-transparent">
      <div slot="header" class="row align-items-center">
        <div class="col">
          <h6 class="text-uppercase text-muted ls-1 mb-1">Faturamento Mês</h6>
        </div>
      </div>
      <line-chart
        :height="350"
        ref="bigChart"
        :chart-data="bigLineChart.chartData"
        :extra-options="bigLineChart.extraOptions"
      ></line-chart>
    </card>
  </div>
</template>
<script>
import * as chartConfigs from "@/components/Charts/config";
import LineChart from "@/components/Charts/LineChart";
import { DashboardFinancialService } from "@/services/customers/dashboard.financial.services";

export default {
  name: "GraphBilling",
  data() {
    return {
      loading: false,
      bigLineChart: {
        activeIndex: 0,
        chartData: {
          datasets: [],
          labels: [],
        },
        extraOptions: chartConfigs.blueChartOptions,
      },
    };
  },
  components: {
    LineChart,
  },
  methods: {
    initBigChart(index) {
      const vm = this;
      vm.loading = true;
      DashboardFinancialService.month()
        .then((response) => {
          let chartData = {
            datasets: [
              {
                label: "Valor",
                data: response.values,
              },
            ],
            labels: response.labels,
          };
          this.bigLineChart.chartData = chartData;
          this.bigLineChart.activeIndex = 0;
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: error,
            duration: 5000,
          });
        })
        .finally(() => (vm.loading = false));
    },
  },
  mounted() {
    this.initBigChart(0);
  },
};
</script>
